import { apiV1 } from "api-v2";

type Discipline = {
	expertise_id: number;
	id: number;
	profile_type_id: number;
	created_at: string;
	name: string;
	updated_at: string;
};

type ExpertiseGroup = {
	expertise_id: number;
	[key: number]: Discipline;
};

type DisciplinesByProfileResponse = {
	[expertise: string]: ExpertiseGroup;
};

type GetListExpertiseAndDisciplinesResponse = {
	data: ExpertiseGroup[];
};

export const getListExpertiseAndDisciplines = async () => {
	const response = await apiV1.get<GetListExpertiseAndDisciplinesResponse>(
		"/expertise-disciplines"
	);
	return response.data;
};

export const getDisciplinesByProfileType = async (profileType: number) => {
	const response = await apiV1.get<DisciplinesByProfileResponse>(
		`/disciplines/by-profile-type/${profileType}`
	);
	return {
		expertiseDisciplinesByProfile: response.data,
	};
};
